import { getApp, getApps, initializeApp } from "firebase/app";

import { isProd } from "./common";

export const firebaseProdConfig = {
  NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyBJXWYRXa6eUKth9chi0WNiYm_cwm18G3c",
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN: "no-ga-576b2.firebaseapp.com",
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: "no-ga-576b2",
  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET: "no-ga-576b2.firebasestorage.app",
  NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "389739306215",
  NEXT_PUBLIC_FIREBASE_APP_ID: "1:389739306215:web:ea316a8f2f9e2667205642",
};

export const firebaseStageConfig = {
  NEXT_PUBLIC_FIREBASE_API_KEY: "AIzaSyDOKqCIXiFhY-ZllyhiCQ5r-YOnP2OLF9Q",
  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN:
    "nordiska-galleriet-group-dev.firebaseapp.com",
  NEXT_PUBLIC_FIREBASE_PROJECT_ID: "nordiska-galleriet-group-dev",
  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET:
    "nordiska-galleriet-group-dev.firebasestorage.app",
  NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID: "1048732899833",
  NEXT_PUBLIC_FIREBASE_APP_ID: "1:1048732899833:web:704790540de340a6918528",
};

const firebaseConfig = isProd() ? firebaseProdConfig : firebaseStageConfig;

const app =
  getApps().length > 0
    ? getApp()
    : initializeApp({
        apiKey: firebaseConfig.NEXT_PUBLIC_FIREBASE_API_KEY,
        authDomain: firebaseConfig.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
        projectId: firebaseConfig.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
        storageBucket: firebaseConfig.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
        messagingSenderId:
          firebaseConfig.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
        appId: firebaseConfig.NEXT_PUBLIC_FIREBASE_APP_ID,
      });

export default app;
